import script from "./DraggableModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DraggableModal.vue?vue&type=script&lang=ts&setup=true"

import "./DraggableModal.vue?vue&type=style&index=0&id=72742994&lang=scss"

const __exports__ = script;

export default __exports__